import React from 'react'
import './Select.scss'

export interface SelectOption<T> {
  label: string
  value: T
}

interface IProps<T> {
  options: SelectOption<T>[] // eslint-disable-line @typescript-eslint/array-type
  value: T
  onSelect?: (value: T) => void
}

export function Select<T>({ value, options, onSelect }: IProps<T>) {
  return (
    <select
      className="select"
      value={value?.toString()}
      onChange={(event) => onSelect(event.target.value as unknown as T)}
      disabled={!onSelect}
    >
      {options.map(({ label, value }, index) => (
        <option key={value?.toString() || index} value={value?.toString()}>
          {label}
        </option>
      ))}
    </select>
  )
}
